import {
  AIProviderConfig,
  GeneratedDramaProject,
  defaultAIProviderConfig,
  saveAIProviderConfig,
  saveLatestDramaProject,
} from './dramaProjectStore';

export interface DramaGenerationRequest {
  keywords: string;
  genre: string;
  duration: string;
  creativity: number;
}

interface DramaGenerationResponse {
  success: boolean;
  data?: GeneratedDramaProject;
  error?: string;
  code?: string;
}

export class DramaGenerationError extends Error {
  code?: string;

  constructor(message: string, code?: string) {
    super(message);
    this.name = 'DramaGenerationError';
    this.code = code;
  }
}

const trimProviderConfig = (config: AIProviderConfig): AIProviderConfig => ({
  apiKey: config.apiKey.trim(),
  baseUrl: config.baseUrl.trim() || defaultAIProviderConfig.baseUrl,
  model: config.model.trim() || defaultAIProviderConfig.model,
});

export const generateDramaProject = async (
  request: DramaGenerationRequest,
  providerConfig: AIProviderConfig,
): Promise<GeneratedDramaProject> => {
  const normalizedProviderConfig = trimProviderConfig(providerConfig);

  saveAIProviderConfig(normalizedProviderConfig);

  const response = await fetch('/api/drama/generate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...request,
      providerConfig: normalizedProviderConfig,
    }),
  });

  const payload = (await response.json()) as DramaGenerationResponse;

  if (!response.ok || !payload.success || !payload.data) {
    throw new DramaGenerationError(payload.error || '生成失败，请稍后再试', payload.code);
  }

  saveLatestDramaProject(payload.data);
  return payload.data;
};
